import testUa from './testUa';

const isQQ = (): boolean => {
  const match = /( qq)/gi;
  const notMatch = /( qqbrowser)/gi;
  return testUa(match) && !testUa(notMatch);
};

export default isQQ;
